import {
	RouterProvider,
	createBrowserRouter
} from 'react-router-dom';

import LoginPage from './pages/Login';
import RootLayout from './pages/RootLayout';
import ErrorPage from './pages/Error';
import NotificationsPage from './pages/Notifications';
import DashboardPage from './pages/Dashboard';
import StudyDetailPage from './pages/StudyDetail';
import TrialArchivePage from './pages/TrialsArchive';
import FaqsPage from './pages/Faqs';
import ContactUsPage from './pages/ContactUs';
import BillingGridPage from './pages/BillingGridPage';

import { CheckAuthLoader } from './utils/checkToken';

import './App.scss';
import ResetPasswd from './components/resetPassword/ResetPassword';
import UserProfilePage from './pages/UserProfilePage';
import HospitalPage from './pages/Hospitals';
import DashboardAdminPage from './pages/DashboardAdmin';
import ReportsPage from './pages/ReportsPage';
import HospitalDashboard from './pages/HospitalDashboard';
import SupportPage from './pages/SupportPage';
import DashboardUsers from './pages/DashboardUsers';

const router = createBrowserRouter([
	{
		path: '/',
		element: <RootLayout />,
		errorElement: <ErrorPage />,
		children: [
			{ index: true, element: <LoginPage /> },
			{
				path: 'login',
				element: <LoginPage />
			},
			{
				path: 'reset-password/:userMail',
				element: <ResetPasswd />
			},
			{
				path: 'notifications',
				element: <NotificationsPage />,
				loader: CheckAuthLoader
			},
			{
				path: 'trials-archive',
				element: <TrialArchivePage />,
				loader: CheckAuthLoader
			},
			{ path: 'faqs', element: <FaqsPage /> },
			{
				path: 'dashboard',
				element: <DashboardPage />,
				loader: CheckAuthLoader
			},
			{
				path: 'dashboard/:studyId',
				element: <StudyDetailPage />
			},
			{
				path: 'contact-us',
				element: <ContactUsPage />
			},
			{
				path: 'trials-archive/:studyId',
				element: <StudyDetailPage />
			},
			{
				path: 'billing-grid/:studyId',
				element: <BillingGridPage />
			},
			{
				path: 'user-profile',
				element: <UserProfilePage />
			},
			{
				path: 'hospitals',
				element: <HospitalPage />
			},
			{
				path: 'reports-page',
				element: <ReportsPage />
			},
			{
				path: 'hospital-admin',
				element: <HospitalDashboard />
			},
			{
				path: 'support-page',
				element: <SupportPage />
			},
			{
				path: 'dashboard-users',
				element: <DashboardUsers />
			},
			{
				path: 'hospital-admin/:studyId',
				element: <StudyDetailPage />
			}
		]
	}
]);
function App() {
	return <RouterProvider router={router} />;
}

export default App;
